import React, { useState } from 'react';
import { useNavigate} from 'react-router-dom';
import { Alert, Heading, Stack, Box, SegmentGroup, HStack, Text, Textarea, Field,Flex, Spacer, Input, Select, createListCollection, Portal, Button} from '@chakra-ui/react';
import axios from 'axios';
import { LuFileSpreadsheet, LuFolderCheck as LuIngest, LuSquareCheck, LuUser, LuSearch, LuTextSearch as LuSearchResults} from "react-icons/lu"
import PageTitle from 'components/ui/PageTitle';
import PageContent from 'components/ui/PageContent';
import SampleSelect from 'components/ui/SampleSelect';

function GenerateReportsPage() {
  const [sample_ids, setSampleIds] = useState([]);

  async function downloadExcelReport(sampleIds) {
    const response = await axios.post('/api/generate_report_excel', sampleIds, {
          responseType: 'blob',
          headers: {
              'Content-Type': 'application/json'
          }
      });

      const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = response.headers.get('content-disposition').split('filename=')[1];
      a.click();
      window.URL.revokeObjectURL(url);
  }

  return (
    <PageContent>
      <PageTitle icon={LuFileSpreadsheet} title="Generate Reports" />

      

      <Heading>Sample Selection</Heading>
      <Flex>
        <SampleSelect onChange={(new_sample_ids) => {
          console.log('sample_ids:', new_sample_ids);
          setSampleIds(new_sample_ids);
        }
        } />
      </Flex>

      <Flex>
        <Button
          onClick={() => downloadExcelReport(sample_ids)}
        >
          Generate Sample Metadata Report (Excel)
        </Button>
      </Flex>

    </PageContent>

  );
}

export default GenerateReportsPage;
